
import { defineComponent, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { getFooterItems } from '@/api/footer.api'
import { useMedia } from '@/utils/useMedia'
import { getUser, useEvent } from '@coderhouse/common'

export default defineComponent({
  components: {},
  setup() {
    const { t } = useI18n()
    const isDesktop = useMedia('(min-width: 1024px)')
    const footer = ref()
    const user = ref()

    onMounted(async () => {
      user.value = await getUser()
      footer.value = await getFooter()
    })

    const getFooter = async () => {
      const res = await getFooterItems(user.value.country)
      return res
    }

    const onClickItem = (item: any) => {
      useEvent('trackEvent', 'landing', 'home-footer', item.text)
    }

    return { t, footer, isDesktop, onClickItem }
  }
})
